export default {
  ApiService: Symbol.for('IApiService'),
  AuthService: Symbol.for('IAuthService'),
  CenterService: Symbol.for('ICenterService'),
  DoctorService: Symbol.for('IDoctorService'),
  EventService: Symbol.for('IEventService'),
  DrugGroupService: Symbol.for('IDrugGroupService'),
  DrugService: Symbol.for('IDrugService'),
  UserService: Symbol.for('IUserService'),
  StatService: Symbol.for('IStatService'),
  StockService: Symbol.for('IStockService'),
  InvitationService: Symbol.for('IInvitationService'),
  PatientService: Symbol.for('IPatientService'),
  Container: Symbol.for('IContainer'),
};